import { Card } from "@mui/material";
import OpportunityForm from "components/opportunities/OpportunityForm/OpportunityForm";
import MDAlert from "components/MDAlert";
import { CustomGetOpportunityQuery, UpdateOpportunityInput } from "generated/graphql";
import useUpdateOpportunity from "hooks/opportunities/useUpdateOpportunity";
import React, { useCallback } from "react";
import { useNavigate } from "react-router";
import { getRoute } from "utils/routing";
type OpportunityForUpdate = NonNullable<CustomGetOpportunityQuery["getOpportunity"]>;

const UpdateOpportunity: React.FC<{ opportunity: OpportunityForUpdate }> = ({ opportunity }) => {
  const [updateOpportunity, { loading, data: updatedOpportunity, isSuccess, getData, error }] =
    useUpdateOpportunity();
  const navigate = useNavigate();
  const formOpportunity = (updatedOpportunity as OpportunityForUpdate) ?? opportunity;

  const handleSubmit = useCallback(
    async (input: UpdateOpportunityInput) => {
      const result = await updateOpportunity({ variables: { input } });
      const success = isSuccess(result.data);
      const data = getData(result);
      return { success, data };
    },
    [updateOpportunity]
  );

  const handleSuccess = useCallback(
    (data) => {
      navigate(getRoute("opportunities.list"));
    },
    [navigate]
  );

  return (
    <>
      {error && (
        <MDAlert color="error">Sorry An error occurred while updating the opportunity</MDAlert>
      )}
      {formOpportunity && (
        <Card>
          <OpportunityForm
            action="upsert"
            loading={loading}
            onSubmit={handleSubmit}
            onSuccess={handleSuccess}
            opportunity={formOpportunity}
          />
        </Card>
      )}
    </>
  );
};

export default UpdateOpportunity;
